import React, { useEffect, useMemo, useState } from "react";
import { Modal, Table, Tag, Alert, Flex, Typography } from "antd";

const { Title } = Typography;

interface ExcludeMemberPreviewModalProps {
  open: boolean;
  onClose: () => void;
  /** Raw rows parsed from the uploaded Excel file (header-keyed). */
  rows: Record<string, any>[];
}

const ExcludeMemberPreviewModal: React.FC<ExcludeMemberPreviewModalProps> = ({
  open,
  onClose,
  rows,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    if (open) setCurrentPage(1);
  }, [open]);

  // Columns are derived dynamically from the uploaded file's headers, so the
  // preview keeps working if the template changes (e.g. Customer Contact -> Email).
  const columns = useMemo(() => {
    const keys = rows.length ? Object.keys(rows[0]) : [];
    return [
      {
        title: "No",
        width: 60,
        render: (_: any, __: any, index: number) =>
          (currentPage - 1) * pageSize + index + 1,
      },
      ...keys.map((key) => ({
        title: key,
        dataIndex: key,
        render: (val: any) =>
          val === "" || val === null || val === undefined ? "-" : String(val),
      })),
    ];
  }, [rows, currentPage, pageSize]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable
      width={isMobile ? 400 : 760}
      style={{ top: 24 }}
      title={
        <Flex align="center" gap={8}>
          <Title level={5} style={{ margin: 0 }}>
            Preview Excluded List
          </Title>
          <Tag color="blue" style={{ marginInlineEnd: 0 }}>
            {rows.length} Members
          </Tag>
        </Flex>
      }
    >
      <Alert
        type="warning"
        showIcon
        style={{ marginBottom: 16 }}
        message="The members listed in the uploaded file will be excluded from receiving this campaign."
      />
      <Table
        className="table-preview"
        size="small"
        scroll={{ x: 500 }}
        rowKey={(_, index) => index!}
        dataSource={rows}
        pagination={{
          current: currentPage,
          pageSize,
          showSizeChanger: false,
          onChange: (page) => setCurrentPage(page),
          showTotal: (total, range) =>
            `Results per Page ${range[1] - range[0] + 1} of ${total} Members`,
        }}
        columns={columns as any}
      />
    </Modal>
  );
};

export default ExcludeMemberPreviewModal;
